module.exports = __webpack_public_path__ + "img/2.00516708.webp";